import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import selectedRating from 'src/examples/Rating/selected';
import withLabelRating from 'src/examples/Rating/withLabel';
import withNumberRating from 'src/examples/Rating/withNumber';
import * as React from 'react';
export default {
  graphql,
  ComponentApi,
  CodeView,
  selectedRating,
  withLabelRating,
  withNumberRating,
  React
};